import { useNavigate } from "react-router-dom";
import paymentimage from "././../../Assets/Icons/paymentsuccess.jpeg";

const PaymentStatus = () => {
  const navigate = useNavigate();
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[#F5F7F9] z-50 px-4 sm:px-6 overflow-hidden"
      // onClick={handleClose}
    >
      <div
        className="bg-gray-50 w-full max-w-sm sm:max-w-md md:max-w-2xl rounded-2xl shadow-lg flex flex-col items-center justify-center animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <main className="flex flex-col items-center justify-center w-full p-6 sm:p-10 md:p-16">
          <img
            src={paymentimage}
            alt="Success"
            className="w-[140px] sm:w-[180px] md:w-[200px]"
          />

          <h2 className="text-base sm:text-lg md:text-2xl font-semibold text-gray-800 text-center mt-6 sm:mt-8">
            Your payment has been successfully processed.
          </h2>

          <p className="text-xs sm:text-sm md:text-base text-black-300 mt-3 sm:mt-4 leading-relaxed text-center max-w-xs sm:max-w-md">
            The interview link has been securely sent to your registered mobile
            number and email address for your convenience.
          </p>

          <button
            className="mt-6 sm:mt-8 bg-[#0071DC] text-white px-8 py-2 rounded-lg hover:bg-[#0071DC] transition duration-200 w-full sm:w-auto"
            // onClick={()=> navigate('/')}
            onClick={() =>
              window.open(
                `https://ipecsolutions.com/hirehub/`,
                "_self"
              )
            }
          >
            OK
          </button>
        </main>
      </div>
    </div>
  );
};

export default PaymentStatus;
